export default {
  title: 'Renomear oferta',
  subtitle: 'Introduza um novo nome para a oferta (máximo 40 caracteres)',
  toasts: {
    success: 'Oferta renomeada com sucesso',
    error: 'Falha ao renomear a oferta',
  },
  buttons: {
    rename: 'Renomear',
  },
  form: {
    title: {
      label: 'Nome da oferta',
      placeholder: 'Introduza o nome da oferta',
    },
  },
};
